module.exports = __webpack_public_path__ + "img/referenceBg.b1697733.png";